const PUBLIC_URL = process.env.PUBLIC_URL
const API_URL = process.env.REACT_APP_API_URL
const SUPER_ADMIN_EMAIL_REGEX = /^.+@webntech.ae$/

if (!API_URL) {
  throw new Error('API_URL is not defined')
}

export {PUBLIC_URL, API_URL, SUPER_ADMIN_EMAIL_REGEX}
